"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    skeletonClassNames: function() {
        return skeletonClassNames;
    },
    useSkeletonStyles_unstable: function() {
        return useSkeletonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const skeletonClassNames = {
    root: 'fui-Skeleton'
};
const useSkeletonStyles_unstable = (state)=>{
    'use no memo';
    state.root.className = (0, _react.mergeClasses)(skeletonClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useSkeletonStyles.styles.js.map
